import clsx from 'clsx';

const SIZE_MAP = {
  sm: { image: 'h-16', glow: 'h-24 w-24' },
  md: { image: 'h-24', glow: 'h-36 w-36' },
  lg: { image: 'h-32', glow: 'h-48 w-48' }
};

const LogoLoader = ({
  message = 'Loading...',
  fullscreen = false,
  size = 'md',
  className = '',
  children
}) => {
  const resolvedSize = SIZE_MAP[size] ?? SIZE_MAP.md;

  const containerClass = fullscreen
    ? 'fixed inset-0 z-50 flex flex-col items-center justify-center bg-white/90 backdrop-blur-sm'
    : 'w-full min-h-[60vh] flex flex-col items-center justify-center py-24';

  return (
    <div
      className={clsx(containerClass, className)}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="relative flex items-center justify-center">
        <span
          className={clsx(
            'absolute inline-flex rounded-full bg-utis-sage/30 blur-2xl animate-logo-loader-glow',
            resolvedSize.glow
          )}
        />
        <img
          src="/assets/utis-logo.png"
          alt="UTIS Logo"
          className={clsx(
            'relative w-auto drop-shadow-lg animate-logo-loader',
            resolvedSize.image
          )}
        />
      </div>
      {message && (
        <p className="mt-6 text-lg font-semibold tracking-wide text-utis-forest/90 text-center">
          {message}
        </p>
      )}
      {children}
    </div>
  );
};

export default LogoLoader;
